import React from 'react'
import { CirclePicker, TwitterPicker, SwatchesPicker } from 'react-color'
// import CirclePicker from 'react-color/lib/components/circle/Circle'
// import TwitterPicker from 'react-color/lib/components/twitter/Twitter'
// import SliderPicker from 'react-color/lib/components/slider/Slider'

export default ({color, palette, type, onChange}) => {
    // const [sliderColor, changeSliderColor] = React.useState(color)
    //
    // const onChangeSlider = (color, e) => {
    //     changeSliderColor(color)
    //     onChange(color)
    // }

    return (
        <React.Fragment>
            {type === 'square' ?
                <TwitterPicker
                    color={color}
                    // colors={palette}
                    onChangeComplete={onChange}
                    triangle='hide'
                />
                : type === 'swatches' ?
                <SwatchesPicker
                    color={color}
                    onChangeComplete={onChange}
                    // color={sliderColor}
                    // colors={palette}
                    // onChangeComplete={onChangeSlider}
                />
                :
                <CirclePicker
                    color={color}
                    colors={palette}
                    onChangeComplete={onChange}
                />
            }
        </React.Fragment>
    )
}
